import en from '@/translation/en.json'
import de from '@/translation/de.json'
import enOnevr from '@/oneVr/language/en_onevr.json'
import deOnevr from '@/oneVr/language/de_onevr.json'

const translations = {
  en: { ...en, ...enOnevr },
  de: { ...de, ...deOnevr },
}

export default translations
